import * as React from "react";
import cn from "clsx";
import { Icon, iconList } from "@innovationnorway/lighthouse-icons";

export type IconProps = {
    size?: "xs" | "s" | "m" | "l" | "xl" | "2xl" | "3xl",
    iconName: string
} & React.HTMLAttributes<HTMLDivElement>;

const InIcon = React.forwardRef<HTMLDivElement, IconProps>(
    (
        {
            className,
            size,
            iconName,
            children,
            style,
            ...props
        },
        ref
    ) => {
        if (iconList.map(icon => icon.name).includes(iconName)){
            return ( <Icon name={iconName} className={cn(
                    `in-icon-in--${ size }`, className)}/>
                );
        } else {
            return false;
        }
    }
);
InIcon.displayName = "Icon";

export { InIcon };